// extracted by mini-css-extract-plugin
export const card = "Card-module--card--3bAyE";
export const cardTitle = "Card-module--cardTitle--hDWbT";
export const cardDescription = "Card-module--cardDescription--2N_Sw";
export const image = "Card-module--image--v6B2j";